import { api } from "./api";

export const getQnAList = async (page: number, size: number) => {
  try {
    const params = { page, size }
    const { data } = await api().get('/qna', { params });
    return data;
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const getQnAData = async (id: number) => {
  try {
    const { data } = await api().get(`/qna/${id}`);
    return data.data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const registerQnA = async (title: string, content: string) => {
  try {
    const body = { title, content };
    const { data } = await api().post('/qna/register', body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const updateQnA = async (id: number, title: string, content: string) => {
  try {
    const body = { title, content };
    const { data } = await api().post(`/qna/update/${id}`, body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteQnA = async (id: number) => {
  try {
    const { data } = await api().post(`/qna/delete/${id}`);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const registerAnswer = async (questionId: number, content: string) => {
  try {
    const body = { questionId, content };
    const { data } = await api().post('/qna/answers/register', body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const updateAnswer = async (id: number, content: string) => {
  try {
    const body = { id, content };
    const { data } = await api().post('/qna/answers/update', body);
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const deleteAnswer = async (answerId: number) => {
  try {
    const params = { answerId };
    const { data } = await api().post('/qna/answers/delete', null, { params });
    return data;
  } catch (e) {
    console.log(e);
    return false;
  }
};